"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMoistureLoadMutation = void 0;
const graphql_tag_1 = __importDefault(require("graphql-tag"));
exports.createMoistureLoadMutation = (0, graphql_tag_1.default) `
  mutation CreateMoistureLoad($input: CreateMoistureLoadInputType!) {
    createMoistureLoad(inputs: $input) {
      id
      moistureLoadId
      revisionNo
      moistureLoadNo
    }
  }
`;
//# sourceMappingURL=create-moisture-load.js.map